const PropTypes = require('prop-types');
const React = require('react');
const formatAmount = require('../shared/format_amount.js');

class Product extends React.Component {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    return this.props.handleClick(this.props.product);
  }

  renderCost() {
    if (!this.props.product.seller_cost) {
      return null;
    }

    return (
      <p className="color-gray">
        {
          I18n.t('js.productBundles.productDetails.sellerCost',
          { cost: formatAmount(this.props.product.seller_cost) })
        }
      </p>
    );
  }

  renderSku() {
    if (!this.props.product.sku) {
      return null;
    }
    return (
      <div className="color-gray mb-0">
        {I18n.t('js.productBundles.productDetails.sku', { sku: this.props.product.sku })}
      </div>
    );
  }

  render() {
    return (
      <div
        className="g-container clickable"
        onClick={this.handleClick}
        key={this.props.product.id}
      >
        <div className="g-col-2">
          <img
            className="img-wide bordered"
            alt={this.props.product.title}
            src={this.props.product._links.photo.href}
          />
        </div>
        <div className="g-col-8">
          <h4 className="strong color-gray">{this.props.product.title}</h4>
          {this.renderSku()}
          <div className="color-gray">
            {
              I18n.t(
                'js.productBundles.productDetails.condition',
                {
                  condition: this.props.product.condition.display_name,
                }
              )
            }
          </div>
          {this.renderCost()}
        </div>
        <div className="g-col-2 align-right">
          <h4 className="strong color-gray">{formatAmount(this.props.product.price)}</h4>
        </div>
      </div>
    );
  }
}

Product.propTypes = {
  product: PropTypes.object.isRequired,
  handleClick: PropTypes.func,
};

module.exports = Product;



// WEBPACK FOOTER //
// ./javascripts/components/product_search_form/product.jsx